module.exports = __webpack_public_path__ + "img/TT.38d32aa2.svg";